export default {
  ACTIVE: 'active',
  SOLD: 'sold',
  PURCHASED: 'purchased',
  PENDING: 'pending',
};
